<div
  class="custom-dropzone"
  ngx-dropzone
  [accept]="'image/*'"
  (change)="onSelect($event)"
>
  <ngx-dropzone-label>
    <div class="label" [class.rx-label]="requiredPrescription==='required-prescription'">
      <ng-container *ngIf="requiredPrescription==='required-prescription'; else defaultLabel">
        <div class="rx-dropzone-prompt-compact">
          <span class="rx-icon-clip">📎</span>
          <span class="rx-prompt-heading">Upload Prescription</span>
          <span class="btn-choose-file">Choose File</span>
        </div>
      </ng-container>

      <ng-template #defaultLabel>
        <h1 *ngIf="!prescription">Drag and drop a file here or click</h1>
        <h1 *ngIf="prescription==='prescription'">Upload your prescription file here or click</h1>

        <svg
          class="MuiSvgIcon-root MuiDropzoneArea-icon"
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
          ></path>
        </svg>
      </ng-template>
    </div>
  </ngx-dropzone-label>

  <ngx-dropzone-image-preview
    ngProjectAs="ngx-dropzone-preview"
    *ngFor="let f of files"
    [file]="f"
    [removable]="true"
    (removed)="onRemove(f)"
  >
  </ngx-dropzone-image-preview>
</div>
<!-- END! custom-dropzone -->
